import { AuraConversation } from '@/types/models/AuraConversationModel';

export interface AuraHistoryResponse {
    success: boolean;
    data: {
        items: AuraConversation[];
        pagination: {
            page: number;
            limit: number;
            total: number;
            pages: number;
        };
        filters: {
            status: string;
            applied: boolean;
        };
    };
}
